import {
  blackWhiteEffect,
  calcThresholds,
  convertWhiteToTransparent,
  createTempCanvas,
  stipplingEffect,
} from "$/util/image_converter";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

function ImageCanvasSimple(props) {
  const {
    imageUrl,
    width = 0,
    height = 0,
    threshold = 0.25,
    minBrightness = 0,
    maxBrightness = 250,
    shadingPattern = "dotwork",
    onImageDataUrl = null,
  } = props;
  const [imageDataUrl, setImageDataUrl] = useState(null);

  const draw = (ctx, img) => {
    ctx.canvas.width = width;
    ctx.canvas.height = height;

    const tempCtx = createTempCanvas(ctx.canvas.width, ctx.canvas.height);

    // Upscale 2x
    tempCtx.drawImage(img, 0, 0, img.width, img.height, 0, 0, width, height);

    if (shadingPattern === "dotwork") {
      stipplingEffect(tempCtx, 5, threshold, [1, 1.5]);
    } else if (shadingPattern === "simple") {
      const { whiteThresh, blackThresh } = calcThresholds(tempCtx, threshold);
      blackWhiteEffect(tempCtx, whiteThresh, blackThresh);
    }
    convertWhiteToTransparent(tempCtx, minBrightness, maxBrightness);

    ctx.drawImage(tempCtx.canvas, 0, 0, width, height);
  };

  const drawImage = (ctx, img) => {
    const tempCtx = createTempCanvas(width, height);
    draw(tempCtx, img);

    ctx.canvas.width = width;
    ctx.canvas.height = height;

    ctx.drawImage(tempCtx.canvas, 0, 0, width, height);
    const dataUrl = ctx.canvas.toDataURL();
    setImageDataUrl(dataUrl);
    if (onImageDataUrl) {
      onImageDataUrl(dataUrl);
    }
  };

  useEffect(() => {
    const img = new Image();
    img.src = imageUrl;
    img.crossOrigin = "Anonymous";

    const ctx = createTempCanvas(width, height, false);

    img.onload = () => {
      drawImage(ctx, img);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageUrl, shadingPattern, threshold]);

  const aspectRatio = width / height;

  return (
    <Box sx={{ width: "100%", aspectRatio, display: "flex", maxHeight: "650px" }}>
      {imageDataUrl ? (
        <img
          src={imageDataUrl}
          alt="Temporary Tattoo"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      ) : (
        <Box sx={{ width: "100%", height: "100%" }} />
      )}
    </Box>
  );
}

export default ImageCanvasSimple;
